var moduleMap = {
	"./account_extension": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_graphql-tag_lib_index_js"), __webpack_require__.e("vendors-node_modules_aircall_icons_dist_AddCircleFilled_js-node_modules_aircall_icons_dist_Ar-d32c13"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-router_react-router"), __webpack_require__.e("src_index_tsx-src_assets_images_addons-self-purchase_ai_assist_pro_training_item_1_webp-src_a-a29811")]).then(() => (() => ((__webpack_require__(8770)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});